import {Store,Module,ActionContext} from 'vuex'
import ListModule from '../list-module'
import ListState from '../list-state'
import Ratio from '../../entities/casis/ratio'
import Ajax from '../../../lib/ajax'
import Util from '../../../lib/util'

interface RatioState extends ListState<Ratio>{
    editModel: Ratio;
    ratios: Array<any>;    
}
class RatioModule extends ListModule<RatioState,any,Ratio>{
    state={
        totalCount:0,
        currentPage:1,
        pageSize: 10,
        list: new Array<Ratio>(),
        loading:false,
        editModel: new Ratio(),
        activeList: new Array<Ratio>(),
        ratios: new Array<any>(),
        path: 'ratios'          
    }
    actions = Util.extend(true, this.base_actions, {
        //extra actions
        async getRatios(context: ActionContext<RatioState, any>, payload: any) {
            if (context.state.loading) return context.state.list;
            context.state.loading = true;
            let reponse = await Ajax.get('/api/ratios/concept', { params: payload.data }).catch(e => {
                context.state.loading = false;
                return Promise.reject(e);
            });
            context.state.loading = false;
            context.state.ratios = reponse.data.result;
            return context.state.ratios;
        },
    });
    mutations = Util.extend(true, this.base_mutations, {
        //extra mutations
    });
}
const ratioModule=new RatioModule();
export default ratioModule;
